import { createInstance } from "i18next";
import Browser from "../../../../external/_pnpm/i18next-browser-languagedetector@7.2.1/external/i18next-browser-languagedetector/dist/esm/i18nextBrowserLanguageDetector.js";
import ICU from "../../../../external/_pnpm/i18next-icu@2.3.0_intl-messageformat@10.5.14/external/i18next-icu/dist/es/index.js";
import { serviceI18NResourcesToBackendPlugin } from "../../../../_virtual/resources.js";
import { defaultI18nConfig } from "./config.js";
const i18next = createInstance();
i18next.use(ICU).use(Browser).use(serviceI18NResourcesToBackendPlugin());
async function initializeLibraryI18n(options) {
  if (i18next.isInitialized) {
    return i18next;
  }
  await i18next.init({
    ...defaultI18nConfig,
    missingKeyHandler: options?.missingKeyHandler,
    saveMissing: false,
    ...options
  });
  return i18next;
}
const i18nLibraryInstance = i18next;
export {
  i18nLibraryInstance,
  initializeLibraryI18n
};
//# sourceMappingURL=library.js.map
